var map = {
	"./aave-logo.svg": 261,
	"./compound-logo.svg": 262,
	"./cream-logo.svg": 263,
	"./curve-logo.svg": 264,
	"./nexus-mutual-logo.svg": 119,
	"./uniswap-logo.svg": 265,
	"./yearn-logo.svg": 266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;